module.exports = __webpack_public_path__ + "static/media/switch_circle.42494dc6.svg";